import axios from 'axios';
const getMyReminders = () => axios.get('/reminders');
const addReminder = ({ conversationId, persistent, time, reminderText }) =>
  axios.post('/reminders/add_reminder', {
    time,
    persistent,
    reminder_text: reminderText,
    conversation_id: conversationId,
  });
const removeReminder = id => axios.get(`/reminders/remove_reminder?id=${id}`);

export default {
  getMyReminders,
  addReminder,
  removeReminder,
};
